import React from 'react';
import { FaHardHat } from 'react-icons/fa';

const Training = () => {
    return (
        <section id="training" className='py-5 bg-light'>
            <div className='container'>
                <div className='row'>
                    <div className='col text-center'>
                        <FaHardHat size={80} color='#ffc107' className='mb-4' />
                        <h2>This page is undergoing construction..</h2>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Training;